<div class="list-group-item hs-lm-list pb-1" *ngIf="folder.layers.length>0">
    <ul class="list-group row">
        <!-- TODO: Remove function call from template -->
        <li *ngFor="let layer of filtered_layers | filter:layerFilter" [id]="layer.idString()"
            class="list-group-item hs-lm-item my-2 my-md-0" [attr.data-test]="layer.title"
            [ngClass]="{'hs-lm-detail-activated':'currentLayer == layer', 'grayed': layer.grayed === true}">
            <div class="d-flex">
                <div class="p-0" [ngClass]="getExclusive(layer.layer) ? 'exclusive' : ''">
                    <!-- TODO: Remove function call from template -->
                    <button type="button" class="btn btn-sm btn-light hs-lm-item-visibility"
                        (click)="hsLayerManagerService.changeLayerVisibility(!layer.visible, layer);hsLayerListService.toggleSublayersVisibility(layer);$event.stopPropagation()"
                        [ngClass]="layer.visible ? 'hs-checkmark' : 'hs-uncheckmark'"></button>
                </div>
                <ng-template #abstractTooltip>
                    <span [innerHtml]="hsLayerManagerService.makeSafeAndTranslate('LAYERS', layer.abstract)"></span>
                </ng-template>
                <div class="align-items-center p-0 hs-lm-item-title flex-grow-1"
                    (click)="hsLayerManagerService.toggleLayerEditor(layer,'sublayers', 'settings')"
                    style="word-break:break-word;" [ngClass]="{'hover': layer.hasSublayers === true}"
                    [ngbTooltip]="layer.abstract ? abstractTooltip : ''" [closeDelay]="hsConfig.layerTooltipDelay || 0">
                    {{layer.title | translateHs : {module: 'LAYERS'} }}
                </div>
                <div class="hs-sublayer-toggle p-0 me-1 ms-1 info_btn" *ngIf="layer.hasSublayers"
                    style="flex-grow: 100; align-self: center;"
                    (click)="hsLayerManagerService.toggleLayerEditor(layer,'sublayers', 'settings')">
                    <span class="me-1 icon-refresh icon-spin" [hidden]="layerLoaded(layer)"></span>
                    <span class="me-1"
                        [ngClass]="{'icon-chevron-right':hsLayerManagerService.currentLayer === layer, 'icon-chevron-down': hsLayerManagerService.currentLayer !== layer}"
                        [hidden]="!layerLoaded(layer)"></span>
                </div>

                <div class="p-0 " [hidden]="layerValid(layer)">
                    <i class="icon-warning-sign hs-lm-warning-scale"
                        [title]="'LAYERMANAGER.layerList.noAvailableInScale' | translateHs  " data-toggle="tooltip"
                        data-container="body" data-placement="auto" [hidden]="!layer.grayed"
                        (click)="$event.stopPropagation()"></i>
                </div>
                <div class="p-0" [hidden]="!layerValid(layer)">
                    <i class="icon-warning-sign alert-danger bg-white hs-lm-warning-error"
                        [title]="'LAYERMANAGER.layerList.layerNotAvailable' | translateHs  " data-toggle="tooltip"
                        data-container="body" data-placement="auto" (click)="$event.stopPropagation()"></i>
                </div>
                <div class="p-0" [hidden]="!getHsLaymanSynchronizing(layer.layer)">
                    <i class="icon-cloudaltsync" [title]="'LAYERMANAGER.layerList.sendingToLayman' | translateHs  "
                        data-toggle="tooltip" data-container="body" data-placement="auto"
                        (click)="$event.stopPropagation()"></i>
                </div>
                <div class="p-0" [hidden]="!hsLayerListService.isLayerQueryable(layer)">
                    <i class="icon-info-sign hs-lm-queryable"
                        [title]="'LAYERMANAGER.layerList.layerIsQueryable' | translateHs  "
                        (click)="$event.stopPropagation()"></i>
                </div>
                <div class="ps-1 info_btn me-1">
                    <span class="icon-settingsthree-gears text-secondary"
                        (click)="hsLayerManagerService.toggleLayerEditor(layer,'settings','sublayers')"
                        [title]="'COMMON.info' | translateHs  " data-toggle="tooltip" data-container="body"
                        data-placement="auto"></span>
                </div>
            </div>
            <hs-layermanager-time-editor [layer]="layer" class="d-flex" *ngIf="showLayerWmsT(layer)">
                <!-- TODO: Remove function call from template -->
            </hs-layermanager-time-editor>
        </li>
    </ul>
</div>
